module.exports = ["Jack Sparrow",
"Crocodile Dundee", 
"Austin Powers",
"Chewbacca",
"Hank Hill",
"Tony Soprano",
" Bill Clinton",
"John F. Kennedy",
"Mozart",
"Hitler",
"John Wayne",
"Michael Jackson",
"Forest Gump",
"Jerry Seinfeld",
"Christopher Walken",
"Jack Nicholson",
"Yoda",
"Roger Rabbit",
"Keanu Reeves",
"Hannibal Lector",
"Arnold Schwarzenegger",
"Sylvester Stallone",
"Robert DeNiro",	
"Al Pacino",
"Batman (Christian Bale Version)",
"Clint Eastwood",
"Woody Allen",
"Jimmy Stewart",
"William Shatner",
"Marlon Brando",
"Julia Child",
"Betty Boop",
"E.T.",
"Snow White",
"Groucho Marx",
"Tom Cruise",
"Wicked Witch of the West",
"Alan Rickman",
"Jaws (that's right, the shark)",
"Napoleon Dynamite",
"Bella Swan",
"The Cowardly Lion",
"Ernest",
"Fonzie",
"Kermit the Frog",
"Cartman",
"Mr. T",
"Darth Vader",
"Miss Piggy",
"Vin Diesel",
"Morgan Freeman",
"Mario",
"Mickey Mouse",
"Popeye",
"James Bond",
"Robin Williams",
"Hugh Grant",
"Patrick Stewart",
"Macauley Culkin",
"Alan Rickman",
"Clint Eastwood",
"Bruce Willis", 
"Gollum",
"The Dude", 
"Freddy Krueger", 
"Raymond Babbitt (of Rain Man)",
"Darth Vader", 
"Jim Carrey", 
"Voldemort",
"Mary Poppins",
"Daniel Plainview (of There Will Be Blood)",
"Michael J. Fox",
"Mel Gibson",
"Gandalf",
"Gordon Gekko",
"The Joker", 
"Rocky Balboa",
"Bill Cosby",
"Samuel L. Jackson"];



// WEBPACK FOOTER //
// ./src/packs/celebs.js